import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types'

import * as d3 from 'd3';

import HoverOver from '../components/HoverOver.js';
import './PercentRadialChart.css';

class PercentRadialChart extends Component {

  constructor(props) {
    super(props);

    this.state = {
      margin: {left: 0, right: 0, top: 0, bottom: 0},
      width: 500,
      height: props.height || 230
    };

    this._currentAngle = 0;
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  componentDidUpdate() {
    setTimeout(this.renderD3.bind(this), 100);
  }

  handelResize(width = 500) {
    this.setState({width: width, height: this.props.height || width});
  }

  shouldComponentUpdate(nextProps, nextState) {
    const widthChange = nextState.width !== this.state.width;
    const percentchange = nextProps.percentile !== this.props.percentile;
    const valueChange = nextProps.value !== this.props.value;
    const hoverChange = nextState.hover !== this.state.hover;

    return widthChange || percentchange || hoverChange || valueChange;
  }

  renderD3() {
    const height = this.state.height - this.state.margin.top - this.state.margin.bottom;
    const props = this.props;
    const self = this;

    const radius = height / 2 - 4;
    const arcwidth = Math.min(26, radius / 3);
    const twoPi = 2 * Math.PI;

    const arc = d3.arc()
      .startAngle(0)
      .outerRadius(radius)
      .innerRadius(radius - arcwidth)
      .cornerRadius(arcwidth / 2);

    const arcTween = () => {
      const newAngle = props.percentile ? props.percentile / 100 * twoPi : 0;
      const i = d3.interpolate(this._currentAngle, newAngle);
      this._currentAngle = newAngle;
      return function (t) {
        return arc.endAngle(i(t))();
      };
    };

    const getHover = () => {
      const content = (
        <div>
          <h4>{props.title}</h4>
          <div><b>Season Total</b> : <i>{d3.format(',')(props.value)}</i></div>
          <div><b>Percentile</b> : <i>{props.percentile}th</i></div>
        </div>
      );

      const r = radius - arcwidth / 2 + 1,
        a = (props.percentile / 100 * twoPi - Math.PI / 2 - arcwidth / 2 / radius),
        x = Math.ceil(Math.cos(a) * r) + self.state.width / 2,
        y = Math.ceil(Math.sin(a) * r) + self.state.height / 2;

      return {x, y, content};
    };

    d3.select(this.refs.background)
      .attr("d", arc.endAngle(twoPi));

    d3.select(this.refs.foreground)
      .on('mouseenter', () => {
        self.setState({hover: getHover()});
      })
      .on("mouseout", () => {
        self.setState({hover: null});
      })
      .transition()
      .attrTween("d", arcTween)
  }

  render() {
    return (
      <div ref="wrapper" className="PercentRadialChart" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={this.state.height}>
          <g transform={"translate(" + (this.state.width / 2) + "," + (this.state.height / 2) + ")"} ref="svg">
            <g className="pie-arc">
              <path ref="background" className="background"></path>
              <path ref="foreground" className="foreground"></path>
            </g>
            <text className="label"
                  textAnchor="middle"
                  dy={-Math.round(this.state.height / 25)}
                  fontSize={Math.round(this.state.height / 9)}
            >{this.props.title}</text>
            <text className="subLabel"
                  textAnchor="middle"
                  dy={Math.round(this.state.height / 10)}
                  fontSize={Math.round(this.state.height / 9)}
            >{d3.format(',.0d')(this.props.value || 0)}</text>
          </g>
        </svg>
        <HoverOver data={this.state.hover}/>
      </div>
    );
  }
}

PercentRadialChart.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number,
  percentile: PropTypes.number
};

export default PercentRadialChart;




// WEBPACK FOOTER //
// ./src/components/PercentRadialChart.js